<template>
  <div id="app">
    <!-- 部分路由不应该包含这个Header -->
    <!--      <Header v-if="exclude.indexOf($route.name) == -1"></Header>-->
    <Header v-if="headerShow"></Header>

    <!--<Header :class="hideClass" data-name=path></Header>-->

    <router-view />
    <!-- 部分路由不应该包含这个Footer -->
    <!--<Footer v-if="excludeFooter.indexOf($route.name) == -1"></Footer>-->
    <Footer v-if="footerShow"></Footer>
    <!-- <Footer v-show="!(path === excludeFooter)" ></Footer>-->
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
export default {
  name: "App",
  data() {
    return {
      headerShow: true,
      footerShow: true,
      path: "",
      exclude: [
        "Login",
        "SignUp",
        "SignUp/CheckPhone",
        "SignUp/InputInfo",
        "SignUp/SignUpDone",
        "forgetPassword"
      ],
      excludeFooter: [
        "Login",
        "SignUp",
        "SignUp/CheckPhone",
        "SignUp/InputInfo",
        "SignUp/SignUpDone",
        "forgetPassword"
      ]
    };
  },
  components: {
    Header,
    Footer
  },
  computed: {
    name() {
      return this.$route.name;
    },
    hideClass() {
      return {
        comHide: this.exclude.includes(this.$route.name)
      };
    }
  },
  // 判断路由
  mounted() {
    this.path = this.$route.name;
    /* console.log(1,this.path)*/
    /*this.path = this.$route.path;*/
  },
  methods: {},
  watch: {
    /*$route(to,from){
      this.path = to.path;
    }*/
    $route(to, from) {
      if (this.$route.path === "/Login" || "/SignUp") {
        this.headerShow = false;
        this.footerShow = false;
      } else {
        this.headerShow = true;
        this.footerShow = true;
      }

      if (
        this.$route.path === "/" ||
        this.$route.path === "/index" ||
        this.$route.path === "/GoodsList" ||
        this.$route.path === "/GoodsDetail" ||
        this.$route.path === "/goodsDetail" ||
        this.$route.path === "/ShopCart" ||
        this.$route.path === "/ShopCart/CheckOder" ||
        this.$route.path === "/ShopCart/PayOder" ||
        this.$route.path === "/ShopCart/CompletePay" ||
        this.$route.path === "/ChineseMedicineZone" ||
        this.$route.path === "/ClinicZone" ||
        this.$route.path === "/BrandZone" ||
        this.$route.path === "/PublicZone" ||
        this.$route.path === "/BrandList" ||
        this.$route.path === "/DailyZone" ||
        this.$route.path === "/ApparatusZone" ||
        this.$route.path === "/ApparatusZone" ||
        this.$route.path === "/EmptyPage" ||
        this.$route.path === "/ControlPinZone" ||
        this.$route.path === "/SubsidyZone" ||
        this.$route.path === "/ScrabbleDoughZone" ||
        this.$route.path === "/ValidityPeriodZone"
      ) {
        this.headerShow = true;
        this.footerShow = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
#app {
  background-color: #f8f8f8;
}
.comHide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue